/*
 *   File : report.js
 *   Author : https://evoqins.com
 *   Description : Monthly report send modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// packages
import React, { useEffect, useState } from 'react';

//Custom components
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { Icon } from '../Icon';
import { CustomDatePicker } from '../FormElements';
import CustomMonthPicker from '../FormElements/custom-month-picker';

const SendReportModal = (props) => {

    const [selectedDate, setSelectedDate] = useState(null);
    const [calendarToggle, setCalendarToggle] = useState(false);
    const [dateError, setDateError] = useState("");

    useEffect(() => {
        setDateError("");
    }, [selectedDate]);

    // handle select date 
    const _handleSelectDate = (day) => {
        setSelectedDate(day);
    };

    // handle clear date
    const _handleClearDate = () => {
        setSelectedDate(null);
    };

    // handle toggle date picker 
    const _handleToggleCalendar = () => {
        setCalendarToggle(!calendarToggle);
    };

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("send-report-modal-close");
        button.click();
        props.handleClose();
    };

    // handle send 
    const _handleSend = (date) => {
        if (selectedDate === null) {
            setDateError("Please select month");
            return;
        }
        props.handleSuccess(date);
        _handleCloseModal();
    };

    return (
        <div className="modal fade"
            id="send-report-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="sendReportModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog- border-radius-28 `}>
                <span id='send-report-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark overflow-visible">

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-4">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            Send monthly report
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-0 pb-3 padding-32px-lr'>
                        {/* <CustomDatePicker label="Select month"
                            placeholder="Select month"
                            selected={selectedDate}
                            toggle={calendarToggle}
                            required={true}
                            error={dateError}
                            handleToggle={_handleToggleCalendar}
                            handleClose={_handleToggleCalendar}
                            handleClear={_handleClearDate}
                            handleSelect={_handleSelectDate} /> */}

                        <CustomMonthPicker label="Select month"
                            required={true}
                            selected={selectedDate}
                            error={dateError}
                            handleClear={_handleClearDate}
                            handleSelect={_handleSelectDate} />
                    </div>

                    {/* Modal footer */}
                    <div className='modal-footer border-0 pt-3 padding-32px-lr padding-32px-bottom gap-4'>
                        <div className='row w-100'>
                            <div className='col-6 ps-0'>
                                <SecondaryButton name="Cancel"
                                    className="py-3 padding-54px-lr w-100"
                                    onClick={_handleCloseModal} />
                            </div>
                            <div className='col-6 pe-0'>
                                <PrimaryButton name="Send"
                                    className="padding-60px-lr w-100"
                                    onClick={() => _handleSend(selectedDate)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default SendReportModal;

SendReportModal.defaultProps = {
    handleClose: () => { }
};